const productUpgradeEligibility = {
  UpgradeNotAllowed: 'UpgradeNotAllowed',
  UpgradeAllowed: 'UpgradeAllowed',
  UpgradeInProgress: 'UpgradeInProgress',
};

export default productUpgradeEligibility;
